/* eslint-ignore */
// @ts-nocheck
import { Steps } from 'intro.js-react';
import 'intro.js/introjs.css';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import TagManager from 'react-gtm-module';
import { toast } from 'react-toastify';
import ReactTooltip from 'react-tooltip';
import PaginationComponent from 'components/layout/Pagination';
import OSModal from 'components/Granel/manutencao/Modal/OS';
import {
  ModalAddressList,
  ModalAdressIcon,
  ModalAdressInfoContainer,
  ModalAdressItem,
  ModalAdressLine,
  ModalAdressLineContainer,
  ModalAdressName,
  ModalAdressNameContainer,
  ModalCloseIcon,
  ModalContainer,
  ModalContent,
  ModalHeader,
  ModalHr,
  ModalLeft,
  ModalSelect,
  ModalTitle,
} from 'components/Granel/new-manutencao/Address/styles';
import OpenOs from 'components/Granel/new-manutencao/Modal/openOs';
import Question1 from 'components/Granel/new-manutencao/Modal/questions/question1';
import Question2 from 'components/Granel/new-manutencao/Modal/questions/question2';
import Question3 from 'components/Granel/new-manutencao/Modal/questions/question3';
import Question4 from 'components/Granel/new-manutencao/Modal/questions/question4';
import Question5 from 'components/Granel/new-manutencao/Modal/questions/question5';
import Question6 from 'components/Granel/new-manutencao/Modal/questions/question6';
import Question7 from 'components/Granel/new-manutencao/Modal/questions/question7';
import Question8 from 'components/Granel/new-manutencao/Modal/questions/question8';
import AlertInline from 'components/layout/AlertInline';
import Loading from 'components/layout/loading';
import Navbar from 'components/layout/NavbarNew';
import UserMenu from 'components/layout/UserMenu';
import api from 'services/api';
import firebase from 'services/firebase';
import { verifyUser } from 'utils/functions';
import AlterDescription from 'utils/functions/AlterDescription';
import scrollBlock from 'utils/functions/scrollBlock';
import { insertScrollTop } from 'utils/scroll';
import { useTour } from 'hooks/useTour';
import { TableWrap } from 'pages/BankSlip/styles';
import TourBalloon from 'newComponents/NewTour/TourBallon';
import { useNotificationContext } from 'hooks/useNotifications';
import {
  getStatusColor,
  getStatusType,
} from 'newComponents/NewNotifications/NotificationItem/util';
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  BoxPadding,
  BtnLine,
  Button,
  Card,
  CardLine,
  Cards,
  Code,
  CodeTitle,
  CreateSection,
  DescriptionLine,
  DuplicateIcon,
  FieldName,
  HeaderPage,
  Hr,
  Input,
  Option,
  Pagination,
  Scrollbar,
  Select,
  Status,
  StatusTitle,
  StyledModal,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Title,
  TitleLine,
  TitleSection,
  Tr,
} from './styles';

const Manutencao = (props) => {
  const [status, setStatus] = useState('OP');
  const [pageTotal, setPageTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [viewMode, setViewMode] = useState(1);
  const [currentBranch, setCurrentBranch] = useState('0101');
  const [showModalAddress, setShowModalAddress] = useState(false);
  const [osModal, setOsModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [bases, setBases] = useState([]);
  const [adresses, setAdresses] = useState([]);
  const [assistancies, setAssistancies] = useState([]);
  const [assistanciesBkp, setAssistanciesBkp] = useState([]);
  const [installBaseSelectedNickName, setInstallBaseSelectedNickName] =
    useState('Selecionar...');
  const [maintenanceEquipment, setMaintenanceEquipment] = useState('');
  const [installBase, setInstallBase] = useState('');
  const [customerSiteId, setCustomerSiteId] = useState('');
  const [labelSelectedOption, setLabelSelectedOption] =
    useState('Selecionar...');
  const [customerId, setCustomerId] = useState('');
  const [topList, setTopList] = useState(false);
  const [stepResponsive, setStepResponsive] = useState(false);
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [serviceOrder, setServiceOrder] = useState(null);
  const [hasFilter, setHasFilter] = useState(false);
  const [token, setToken] = useState('');
  const [showModalSolicitation, setShowModalSolicitation] = useState(false);
  const [reason, setReason] = useState('');
  const [attendanceScriptEquipment, setAttendanceScriptEquipment] =
    useState('');
  const [showModal, setShowModal] = useState(false);

  const { showTour, tourType, tourStep, setTourType, setSteps } = useTour();
  const { loadNotifications } = useNotificationContext();

  useEffect(() => {
    setTourType('assistancies');
    setSteps(2);
  }, [showTour, setTourType, setSteps]);

  const applyFilterAndRequestAssistancies = async () => {
    setLoading(true);
    const tokenLS = localStorage.getItem('@UltragazEmpresarial:accessToken');
    const customerIdLS = localStorage.getItem(
      '@UltragazEmpresarial:customerId'
    );
    const customerSiteIdLS = localStorage.getItem(
      '@UltragazEmpresarial:customerSiteId'
    );
    const customerCodeLS = localStorage.getItem(
      '@UltragazEmpresarial:customerCode'
    );
    const customerSiteCodeLS = localStorage.getItem(
      '@UltragazEmpresarial:customerSiteCode'
    );

    const { search } = window.location;
    const params = new URLSearchParams(search);
    const beginDate = await params.get('begin-date');
    const endDate = await params.get('end-date');

    if (beginDate && endDate) {
      setHasFilter(true);
    }
    setToken(tokenLS);
    setCustomerId(customerIdLS);
    setCustomerSiteId(customerSiteIdLS);
    if (tokenLS) {
      getInstallBases(tokenLS, customerIdLS, customerSiteIdLS);
      requestAssistancies(
        tokenLS,
        customerIdLS,
        customerSiteIdLS,
        beginDate,
        endDate
      );
    } else {
      verifyUser(props);
    }
  };

  useEffect(() => {
    applyFilterAndRequestAssistancies();
  }, []);

  const goTop = () => {
    const width = window.innerWidth;

    if (width <= 371) {
      insertScrollTop(510);
    } else if (width <= 480) {
      insertScrollTop(480);
    } else {
      insertScrollTop(460);
    }
  };

  const clearFilter = () => {
    window.location.href = '/manutencao';
  };

  const requestCreateAssistance = (data) => {
    firebase.analytics().logEvent('solicitacao_manutencao', {
      customerCode: localStorage.getItem('@UltragazEmpresarial:customerCode'),
      userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      events: {
        solicitacao_manutencao: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
      dataLayer: {
        solicitacao_manutencao: {
          customerCode: localStorage.getItem(
            '@UltragazEmpresarial:customerCode'
          ),
          userEmail: localStorage.getItem('@UltragazEmpresarial:loginEmail'),
        },
      },
    });
    setLoading(true);
    const tokenLS = localStorage.getItem('@UltragazEmpresarial:accessToken');
    const { props, values } = data;
    let attendanceScriptResult;
    let subject;
    let apiURL = 'industrial/case/v1/assistancies';

    switch (props.attendanceCodeOS) {
      case '010101:1':
        attendanceScriptResult = 'Está sentindo cheiro de gás? Sim';
        subject = 'Manutenção corretiva';
        break;
      case '0101020102:3':
        attendanceScriptResult =
          'Está sentindo cheiro de gás? : Não | Há falta de gás? O gás está fraco? : Sim | O tanque está com GLP? : Não';
        subject = 'Manutenção corretiva';
        break;
      case '010102010101:3':
        attendanceScriptResult =
          'Está sentindo cheiro de gás? : Não | Há falta de gás? O gás está fraco? : Sim | O tanque está com GLP? : Sim | O registro está aberto? : Sim';
        subject = 'Manutenção corretiva';
        break;
      case '01010201010201':
        attendanceScriptResult =
          'Está sentindo cheiro de gás? : Não | Há falta de gás? O gás está fraco? : Sim | O tanque está com GLP? : Sim | O registro está aberto? : Não | Problema resolvido? : Sim';
        subject = 'Dúvidas e Esclarecimentos';
        break;
      case '01010201010202:3':
        attendanceScriptResult =
          'Está sentindo cheiro de gás? : Não | Há falta de gás? O gás está fraco? : Sim | O tanque está com GLP? : Sim | O registro está aberto? : Não | Problema resolvido? : Não';
        subject = 'Manutenção corretiva';
        break;
      case '0101020201:3':
        attendanceScriptResult = `Está sentindo cheiro de gás? : Não | Há falta de gás? O gás está fraco? : Não | Percebeu-se defeito em algum equipamento? : Sim | Qual equipamento? : ${maintenanceEquipment}`;
        subject = 'Manutenção corretiva';
        break;
      case '010102020201:1':
        attendanceScriptResult =
          'Está sentindo cheiro de gás? : Não | Há falta de gás? O gás está fraco? : Não | Percebeu-se defeito em algum equipamento? : Não | Houve algum incidente ou ocorrência? : Sim';
        subject = 'Manutenção corretiva';
        break;
      case '01010202020201:2':
        attendanceScriptResult =
          'Está sentindo cheiro de gás? : Não | Há falta de gás? O gás está fraco? : Não | Percebeu-se defeito em algum equipamento? : Não | Houve algum incidente ou ocorrência? : Não | A central está fora de norma? : Sim';
        subject = 'Manutenção corretiva';
        break;
      case '01010202020202:4':
        attendanceScriptResult =
          'Está sentindo cheiro de gás? : Não | Há falta de gás? O gás está fraco? : Não | Percebeu-se defeito em algum equipamento? : Não | Houve algum incidente ou ocorrência? : Não | A central está fora de norma? : Não';
        subject = 'Manutenção corretiva';
        break;
      default:
        break;
    }

    let fixedJustify = values.justification;

    const detail = `Nome: ${values.name} | Telefone: ${values.phone} | Justificativa: ${fixedJustify}`;
    const header = {
      'Content-Type': 'application/json',
      access_token: tokenLS,
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const contactIdSf = localStorage.getItem(
      '@UltragazEmpresarial:contactIdSf'
    );

    let body = {
      customerSiteId,
      installBase,
      subject,
      detail,
      reason: props.reason,
      attendanceCodeOS: props.attendanceCodeOS,
      attendanceScriptEquipment: maintenanceEquipment,
      attendanceScriptResult,
      ...(contactIdSf && { contactIdSf }),
    };

    if (subject === 'Dúvidas e Esclarecimentos') {
      fixedJustify =
        'Cliente estava com dúvida em relação ao Registro, cliente foi orientado a abrir o registro lentamente e o problema foi resolvido';
      apiURL = 'industrial/case/v1/doubts-clarifications';

      body = {
        customerSiteId,
        installBase,
        detail,
        ...(contactIdSf && { contactIdSf }),
      };
    }

    api
      .post(apiURL, body, parameters)
      .then((res) => {
        loadNotifications();
        setShowModalSolicitation(false);
        setMaintenanceEquipment('');
        if (res.status === 201) {
          if (subject === 'Dúvidas e Esclarecimentos') {
            toast.success('Ficamos contentes que seu problema foi resolvido!');
          } else {
            toast.success(
              'Entraremos em contato para agendamento da visita técnica'
            );
          }
          setTimeout(function () {
            window.location = '/manutencao';
          }, 2000);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        setShowModalSolicitation(false);
        setMaintenanceEquipment('');
        const erro = err.response;
        if (erro) {
          const { message } = err?.response?.data;
          if (err?.response?.status !== 401) {
            toast.error(message);
          }
        } else if (err?.response?.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  const requestDoubts = useCallback(
    async (
      tokenParam,
      customerIdParam,
      customerSiteIdParam,
      assistanciesResponse
    ) => {
      const header = {
        'Content-Type': 'application/json',
        access_token: tokenParam,
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      const { search } = window.location;
      const params = new URLSearchParams(search);
      const caseId = await params.get('caseId');

      let url2 = `/industrial/case/v1/doubts-clarifications?_limit=100000&_offset=0&customer-site-id=${customerSiteIdParam}&customer-id=${customerIdParam}&_expand=requestedCase`;
      if (caseId) {
        url2 = `/industrial/case/v1/doubts-clarifications/${caseId}`;
      }

      api
        .get(url2, parameters)
        .then((res) => {
          loadNotifications();
          const response = res.data;

          const newArray = assistanciesResponse.concat(response);
          newArray.sort(
            (a, b) =>
              new Date(b.requestedCase.creationDate) -
              new Date(a.requestedCase.creationDate)
          );

          if (caseId) {
            setAssistancies([
              newArray.length > 0 ? newArray.slice(0, 10) : newArray,
            ]);
            setAssistanciesBkp([newArray]);
            const totalItens = newArray?.length ? newArray.length : 0;
            const total = totalItens >= 10 ? totalItens / 10 : 1;
            setPageTotal(total);
            setHasFilter(true);
            setLoading(false);
          } else {
            setAssistancies(
              newArray.length > 0 ? newArray.slice(0, 10) : newArray
            );
            const totalItens = newArray?.length ? newArray.length : 0;
            const total = totalItens >= 10 ? totalItens / 10 : 1;
            setAssistanciesBkp(newArray);
            setPageTotal(total);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          const erro = err.response;
          if (erro) {
            const { message } = err.response.data;
            if (err?.response?.status !== 401) {
              toast.error(message);
            }
          } else if (err.response.status !== 401) {
            toast.error('Ocorreu um erro interno na aplicação');
          }
        });
    },
    []
  );

  const requestAssistancies = useCallback(
    async (tokenParam, customerIdParam, customerSiteIdParam) => {
      setLoading(true);
      let assistanciesResponse = [];
      const header = {
        'Content-Type': 'application/json',
        access_token: tokenParam,
      };
      const parameters = {
        method: 'GET',
        headers: header,
      };
      const { search } = window.location;
      const params = new URLSearchParams(search);
      const caseId = await params.get('caseId');
      let url = `/industrial/case/v1/assistancies?_limit=100000&_offset=0&customer-site-id=${customerSiteIdParam}&customer-id=${customerIdParam}&_expand=requestedCase`;
      if (caseId) {
        url = `/industrial/case/v1/assistancies/${caseId}`;
      }
      api
        .get(url, parameters)
        .then(async (res) => {
          loadNotifications();
          const response = res.data;
          if (caseId) {
            assistanciesResponse =
              response.length > 0 ? response.slice(0, 10) : response;
            setAssistancies([assistanciesResponse]);
            const total = response.length ? response.length / 10 : 1;
            setAssistanciesBkp([assistanciesResponse]);
            setPageTotal(parseInt(total));
            setHasFilter(true);
          } else {
            const total = response.length ? response.length / 10 : 1;
            assistanciesResponse =
              response.length > 0 ? response.slice(0, 10) : response;
            setAssistancies(assistanciesResponse);
            setAssistanciesBkp(assistanciesResponse);
            setPageTotal(parseInt(String(total)));
          }
          requestDoubts(
            tokenParam,
            customerIdParam,
            customerSiteIdParam,
            assistanciesResponse
          );
        })
        .catch((err) => {
          setLoading(false);
          const erro = err.response;
          if (erro) {
            const { message } = err.response.data;
            if (err.response.status !== 401) {
              toast.error(message);
            }
          } else if (err.response.status !== 401) {
            toast.error('Ocorreu um erro interno na aplicação');
          }
        });
    },
    [requestDoubts]
  );

  const getInstallBases = (
    tokenParam,
    customerIdParam,
    customerSiteIdParam
  ) => {
    const header = {
      'Content-Type': 'application/json',
      access_token: tokenParam,
    };
    const parameters = {
      method: 'GET',
      headers: header,
    };
    api
      .get(
        `industrial/customer/v1/customers/me/bases?customer-site-id=${customerSiteIdParam}`,
        parameters
      )
      .then(async (res) => {
        setLoading(false);
        const response = res.data;
        const adresses = response;
        const bases = [];

        if (adresses.length > 0) {
          const address = adresses[0];
          let selected = false;
          if (address.installBase.length > 0) {
            address.installBase.map((base) => {
              if (base.status.toLowerCase() === 'a') {
                bases.push(base);
                if (!selected) {
                  selectBase(base.nickname, base.name);
                  const { name } = base;
                  localStorage.setItem(
                    '@UltragazEmpresarial:selectedBase',
                    name
                  );
                  setInstallBaseSelectedNickName(name);
                  setReason(name);
                  selected = true;
                }
              }
            });
          }
          adresses[0].installBase = bases;
        }
        setAdresses(adresses);
        setBases(bases);
      })
      .catch((err) => {
        setLoading(false);
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  const selectBase = (nickname, selectedOptionParam) => {
    localStorage.setItem('base', selectedOptionParam);
    setInstallBaseSelectedNickName(selectedOptionParam);
    setSelectedOption(selectedOptionParam);
    setLabelSelectedOption(nickname);
    setInstallBase(selectedOptionParam);
  };

  const handleStatusChange = (statusParam) => {
    setActivePage(1);
    setStatus(statusParam);
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleUserResponse = (branch) => {
    setCurrentBranch(branch);
  };

  const handleCloseModal = () => {
    setShowModalSolicitation(false);
  };

  const handleMaintenanceEquipment = (equipment) => {
    handleUserResponse('0101020201:3');
    setMaintenanceEquipment(equipment);
  };

  const handleShowModalSolicitation = () => {
    setShowModalSolicitation(!showModalSolicitation);
    setCurrentBranch('0101');
  };

  const handleShowQuestionModal = () => {
    switch (currentBranch) {
      case '0101':
        return (
          <Question1
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            handleClick={handleUserResponse}
          />
        );
        break;

      case '010102':
        return (
          <Question2
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            handleClick={handleUserResponse}
          />
        );
        break;

      case '01010201':
        return (
          <Question3
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            handleClick={handleUserResponse}
          />
        );
        break;

      // Registro aberto?
      case '0101020101':
        return (
          <Question4
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            handleClick={handleUserResponse}
          />
        );
        break;

      case '01010201019':
        return (
          <Question5
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            handleClick={handleUserResponse}
          />
        );
        break;

      case '01010202':
        return (
          <Question6
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            handleClick={handleUserResponse}
          />
        );
        break;

      case '010102029':
        return (
          <Question7
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            handleEquipment={handleMaintenanceEquipment}
            handleClick={handleUserResponse}
          />
        );
        break;

      case '0101020202':
        return (
          <Question8
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            handleClick={handleUserResponse}
          />
        );
        break;

      case '010101:1':
        return (
          <OpenOs
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            request={requestCreateAssistance}
            hideModal={handleShowModalSolicitation}
            customerSiteId={customerSiteId}
            installBase={installBase}
            attendanceCodeOS="010101:1"
            reason="Vazamento"
            handleClick={handleUserResponse}
          />
        );
        break;

      // Pergunta 3 = NÃO: Abrir OS Corretiva Motivo: Falha no fornecimento
      case '0101020102:3':
        return (
          <OpenOs
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            request={requestCreateAssistance}
            hideModal={handleShowModalSolicitation}
            customerSiteId={customerSiteId}
            installBase={installBase}
            attendanceCodeOS="0101020102:3"
            reason="Falha no Fornecimento"
            handleClick={handleUserResponse}
          />
        );
        break;

      // Pergunta 4 = SIM: Abrir OS Corretiva. Motivo: Falha no Fornecimento
      case '010102010101:3':
        return (
          <OpenOs
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            request={requestCreateAssistance}
            hideModal={handleShowModalSolicitation}
            customerSiteId={customerSiteId}
            installBase={installBase}
            attendanceCodeOS="010102010101:3"
            reason="Falha no Fornecimento"
            handleClick={handleUserResponse}
          />
        );
        break;

      case '01010201010201':
        return (
          <OpenOs
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            hideJustification
            request={requestCreateAssistance}
            hideModal={handleShowModalSolicitation}
            customerSiteId={customerSiteId}
            installBase={installBase}
            attendanceCodeOS="01010201010201"
            reason="Finalizar caso no SF e não abrir OS no Máximo"
            handleClick={handleUserResponse}
            messageTitle="Ficamos contentes que seu problema foi resolvido!"
            message="Apenas para registro, solicitamos que preencha os campos abaixo."
          />
        );
        break;

      case '01010201010202:3':
        return (
          <OpenOs
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            request={requestCreateAssistance}
            hideModal={handleShowModalSolicitation}
            customerSiteId={customerSiteId}
            installBase={installBase}
            attendanceCodeOS="01010201010202:3"
            reason="Falha no Fornecimento"
            handleClick={handleUserResponse}
          />
        );
        break;

      case '0101020201:3':
        return (
          <OpenOs
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            request={requestCreateAssistance}
            hideModal={handleShowModalSolicitation}
            customerSiteId={customerSiteId}
            installBase={installBase}
            attendanceCodeOS="0101020201:3"
            equipment={maintenanceEquipment}
            reason="Defeito de instalação"
            handleClick={handleUserResponse}
          />
        );
        break;

      case '010102020201:1':
        return (
          <OpenOs
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            request={requestCreateAssistance}
            hideModal={handleShowModalSolicitation}
            customerSiteId={customerSiteId}
            installBase={installBase}
            attendanceCodeOS="010102020201:1"
            reason="Incidente"
            handleClick={handleUserResponse}
          />
        );
        break;

      // Pergunta 9 = SIM: Abrir OS Adequação. Motivo: Central Fora de Norma
      case '01010202020201:2':
        return (
          <OpenOs
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            request={requestCreateAssistance}
            hideModal={handleShowModalSolicitation}
            customerSiteId={customerSiteId}
            installBase={installBase}
            attendanceCodeOS="01010202020201:2"
            reason="Central Fora de Norma"
            handleClick={handleUserResponse}
          />
        );
        break;

      // Pergunta 9 = NÃO: Abrir OS Corretiva. Motivo: Não Especificado
      case '01010202020202:4':
        return (
          <OpenOs
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            request={requestCreateAssistance}
            hideModal={handleShowModalSolicitation}
            customerSiteId={customerSiteId}
            installBase={installBase}
            attendanceCodeOS="01010202020202:4"
            reason="Não Especificado"
            handleClick={handleUserResponse}
          />
        );
        break;

      default:
        return (
          <OpenOs
            close={() => {
              setShowModalSolicitation(false);
              setCurrentBranch('0101');
              setAttendanceScriptEquipment('');
            }}
            request={requestCreateAssistance}
            hideModal={handleShowModalSolicitation}
            customerSiteId={customerSiteId}
            installBase={installBase}
            attendanceCodeOS="01010202020201:2"
            reason="Incidente"
            handleClick={handleUserResponse}
          />
        );
        break;
    }
  };

  const handleShow = () => {
    const refuelDate = localStorage.getItem('current_date');
    if (refuelDate && installBaseSelectedNickName) {
      setShowModal(true);
    } else {
      toast.error('Selecione uma base e uma data para continuar!');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSelectedOption(value);
    selectBase(value, name);
  };

  const openModal = () => {
    if (adresses.length != 0) {
      setShowModalAddress(!showModalAddress);
    } else {
      toast.error('Você não possuí nenhuma base de instalação disponível');
    }
  };

  const handleSelectAddress = (nickname, name) => {
    selectBase(nickname, name);
    setShowModalAddress(!showModalAddress);
  };

  const getColor = (statusParam) => {
    switch (statusParam) {
      case 'APROVADO':
      case 'AGEREA':
      case 'OSGER':
      case 'PEDAGE':
      case 'FECHAR':
      case 'SOLATE':
        return '#75b943';
      case 'GREOSAUT':
      case 'AGUANA':
      case 'AGUCONLOG':
      case 'GERPEDAUT':
      case 'AGUTRA':
      case 'RENDATCLI':
      case 'CANEA':
      case 'ERRINT':
        return '#f0b01b';
      case 'SNOREC':
      case 'CANREA':
      case 'ERRO':
        return '#e34e2a';
      default:
        return '#f0b01b';
    }
  };

  const paginationBack = (newPage) => {
    if (newPage > 0) {
      const result = assistanciesBkp.slice((newPage - 1) * 10, newPage * 10);
      setActivePage(newPage);
      setAssistancies(result);
    }

    goTop();
  };

  const paginationRight = (newPage) => {
    if (newPage <= parseInt(assistanciesBkp.length / 10)) {
      const result = assistanciesBkp.slice((newPage - 1) * 10, newPage * 10);
      setActivePage(newPage);
      setAssistancies(result);
    } else if (newPage <= Math.ceil(assistanciesBkp.length / 10)) {
      const result = assistanciesBkp.slice(
        (newPage - 1) * 10,
        assistanciesBkp.length
      );
      setActivePage(newPage);
      setAssistancies(result);
    }

    goTop();
  };

  const handleSelectChange = async (event) => {
    const name = event.target.value;
    localStorage.setItem('@UltragazEmpresarial:selectedBase', name);
    setInstallBaseSelectedNickName(name);
    setReason(name);
  };

  const handleShowModal = () => {
    if (reason) {
      setShowModalSolicitation(true);
    } else {
      toast.error('Selecione um local para continuar!');
    }
  };

  const getSelectedBase = (response) => {
    return (
      response && response.length === 1 && response[0].installBase.length === 1
    );
  };

  const handleChangePage = (pageNumber) => {
    if (activePage < pageNumber) {
      paginationRight(pageNumber);
    }
    if (activePage > pageNumber) {
      paginationBack(pageNumber);
    }

    goTop();
  };

  return (
    <>
      <Navbar selected="manutencao" openSubMenu="main-manutencao" withTable>
        <UserMenu breadcrump="› Manutenção" intro={() => true} />
        <Scrollbar id="cards">
          <BoxPadding>
            <HeaderPage>
              <Title>Manutenção</Title>
            </HeaderPage>

            <AlertInline text="Este serviço é exclusivo para situações de vazamento, problemas na central de gás, equipamentos e tubulação." />

            <Hr />
            <TableWrap
              showTour={
                showTour && tourType === 'assistancies' && tourStep === 1
              }
            >
              <TitleSection>Selecione o local de manutenção</TitleSection>
              <CreateSection className="intro-solicite">
                <Input>
                  <FieldName>Local de manutenção *</FieldName>
                  <Select
                    name="reason"
                    value={reason}
                    onChange={handleSelectChange}
                    onClick={() => toast.dismiss()}
                  >
                    <Option disabled selected value="vazio">
                      Selecione uma opção...
                    </Option>
                    {adresses.map((address) => {
                      return address.installBase.map((base) => {
                        return (
                          <Option
                            value={base.name}
                            key={base.name}
                            selected={getSelectedBase(adresses)}
                          >
                            {` ${base.nickname}`}
                          </Option>
                        );
                      });
                    })}
                  </Select>
                </Input>

                <Button onClick={() => handleShowModal()}>Solicitar</Button>
              </CreateSection>
              {showTour && tourType === 'assistancies' && tourStep === 1 && (
                <TourBalloon
                  title="Campos para solicitação de manutenção"
                  content="Aqui será necessário informar o local de Manutenção e responder as perguntas que serão apresentadas. Basta clicar em 'Solicitar'."
                  position={{
                    left: '0',
                    right: '0',
                    top: '95%',
                    arrowPosition: 'top',
                    maxWidth: 300,
                    boxShadow: false,
                  }}
                />
              )}
            </TableWrap>

            <TitleSection>Histórico de manutenção</TitleSection>
          </BoxPadding>
          <TableWrap
            showTour={showTour && tourType === 'assistancies' && tourStep === 2}
          >
            <Table className="intro-solicitacoes">
              <Thead id="headerTable">
                <Th>Número do Protocolo</Th>
                <Th>Data solicitada</Th>
                <Th>Data prevista de atendimento</Th>
                <Th>Descrição</Th>
                <Th>Equipe técnica</Th>
                <Th>Status</Th>
                <Th />
              </Thead>
              <Tbody>
                {assistancies.length > 0 &&
                  assistancies.map((assistancie) => {
                    return (
                      <Tr key={assistancie.caseId}>
                        <Td>{assistancie.caseNumber}</Td>
                        <Td>
                          {moment(
                            assistancie.requestedCase.creationDate
                          ).format('DD/MM/YYYY')}
                        </Td>
                        <Td>
                          {assistancie?.serviceOrder?.attendanceForecastDate
                            ? moment(
                                assistancie?.serviceOrder
                                  ?.attendanceForecastDate
                              ).format('DD/MM/YYYY')
                            : 'Pendente'}
                        </Td>
                        <Td>{assistancie.subject}</Td>
                        <Td>
                          {assistancie?.serviceOrder?.team
                            ? assistancie.serviceOrder.team
                            : '-'}
                        </Td>
                        <Td>
                          <Status
                            color={() => {
                              return getStatusColor(
                                assistancie?.status?.code ?? null,
                                'assistancie'
                              );
                            }}
                          />
                          <StatusTitle>
                            {getStatusType(
                              assistancie?.status?.code ?? null,
                              'assistancie',
                              false
                            )}
                          </StatusTitle>
                        </Td>
                        <Td>
                          {assistancie.serviceOrder && (
                            <>
                              <DuplicateIcon
                                className="mdi mdi-information-outline"
                                aria-label="Mais Informações"
                                data-tip
                                data-for="info-boleto"
                                onClick={(e) => {
                                  setServiceOrder(assistancie.serviceOrder);
                                  setOsModal(true);
                                }}
                              />
                              <ReactTooltip
                                id="info-boleto"
                                place="top"
                                effect="float"
                                type="info"
                                style={{
                                  backgroundColor: 'rgb(0, 255, 30)',
                                  color: '#222',
                                }}
                              >
                                Mais informações
                              </ReactTooltip>
                            </>
                          )}
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
            {showTour && tourType === 'assistancies' && tourStep === 2 && (
              <TourBalloon
                title="Lista de solicitações"
                content="Veja todas as suas solicitações de manutenção realizadas através do Portal."
                position={{
                  left: '50%',
                  right: '0',
                  top: '-192px',
                  arrowPosition: 'bottom',
                  maxWidth: 'unset',
                  boxShadow: false,
                  width: '492px',
                  transform: 'translateX(-50%)',
                }}
              />
            )}
          </TableWrap>

          <Cards className="intro-solicitacoes-mobile">
            {assistancies.length > 0 &&
              assistancies.map((assistancie) => {
                return (
                  <Card key={assistancie.caseId}>
                    <CardLine>
                      <CodeTitle>Número do Protocolo</CodeTitle>
                      <Code>{assistancie.caseNumber}</Code>
                    </CardLine>

                    <Hr />

                    <CardLine>
                      <TitleLine>Data solicitada</TitleLine>
                      <DescriptionLine>
                        {moment(assistancie.requestedCase.creationDate).format(
                          'DD/MM/YYYY'
                        )}
                      </DescriptionLine>
                    </CardLine>

                    <Hr />

                    <CardLine>
                      <TitleLine>Data prevista de atendimento</TitleLine>
                      <DescriptionLine>
                        {assistancie?.serviceOrder?.attendanceForecastDate
                          ? moment(
                              assistancie?.serviceOrder?.attendanceForecastDate
                            ).format('DD/MM/YYYY')
                          : 'Pendente'}
                      </DescriptionLine>
                    </CardLine>

                    <Hr />

                    <CardLine>
                      <TitleLine>Equipe técnica</TitleLine>
                      <DescriptionLine>
                        {assistancie?.serviceOrder?.team
                          ? assistancie.serviceOrder.team
                          : '-'}
                      </DescriptionLine>
                    </CardLine>

                    <Hr />

                    <CardLine>
                      <TitleLine>Status</TitleLine>
                      <DescriptionLine>
                        <Status
                          color={() => {
                            return getStatusColor(
                              assistancie?.status?.code ?? null,
                              'assistancie'
                            );
                          }}
                        />
                        <StatusTitle>
                          {getStatusType(
                            assistancie?.status?.code ?? null,
                            'assistancie',
                            false
                          )}
                        </StatusTitle>
                      </DescriptionLine>
                    </CardLine>
                    {assistancie.serviceOrder && (
                      <>
                        <Hr />
                        <CardLine>
                          <BtnLine
                            onClick={() => {
                              setServiceOrder(assistancie.serviceOrder);
                              setOsModal(true);
                            }}
                          >
                            Clique aqui para mais informações
                          </BtnLine>
                        </CardLine>
                      </>
                    )}
                  </Card>
                );
              })}
          </Cards>

          {assistanciesBkp.length > 0 && pageTotal > 0 && (
            <PaginationComponent
              totalPages={Number(pageTotal)}
              isLoading={loading}
              selectedPage={activePage}
              onPageChange={handleChangePage}
            />
          )}
        </Scrollbar>
      </Navbar>
      <StyledModal
        show={showModalSolicitation}
        onHide={() => {
          setShowModalSolicitation(false);
          setCurrentBranch('0101');
          setAttendanceScriptEquipment('');
        }}
        dialogClassName="maik"
        aria-labelledby="example-custom-modal-styling-title"
        size="md"
        centered
        animation={false}
      >
        {handleShowQuestionModal()}
      </StyledModal>
      <Modal
        show={showModalAddress}
        onHide={() => setShowModalAddress(false)}
        size="lg"
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        centered
        animation={false}
      >
        <ModalContainer>
          <ModalHeader>
            <ModalLeft>
              <ModalTitle>Selecione um Local</ModalTitle>
            </ModalLeft>
            <ModalCloseIcon
              onClick={() => setShowModalAddress(false)}
              title="Fechar"
              className="mdi mdi-close"
            />
          </ModalHeader>
          <ModalContent>
            Selecione um local para criar a solicitação de manutenção:
          </ModalContent>
          {adresses.map((adress) =>
            adress.installBase.map((base) => (
              <ModalAddressList
                key={base.name}
                onClick={() => handleSelectAddress(base.nickname, base.name)}
              >
                <ModalAdressItem name={base.name} id={base.name}>
                  <ModalSelect
                    checked={selectedOption === base.name}
                    onChange={handleChange}
                    name={base.name}
                    value={base.nickname}
                    id={base.name}
                    type="radio"
                  />
                  <ModalAdressInfoContainer>
                    <ModalAdressNameContainer>
                      <ModalAdressIcon className="mdi mdi-map-marker" />
                      <ModalAdressName>{base.nickname}</ModalAdressName>
                    </ModalAdressNameContainer>
                    <ModalAdressLineContainer>
                      <ModalAdressLine>
                        {`${adress.addressLine}, ${adress.addressNumber} -
                        ${adress.city} - ${adress.stateCode},${adress.cep}`}
                      </ModalAdressLine>
                    </ModalAdressLineContainer>
                  </ModalAdressInfoContainer>
                </ModalAdressItem>
                {adresses.length <= 1 ? null : <ModalHr />}
              </ModalAddressList>
            ))
          )}
        </ModalContainer>
      </Modal>
      <Modal
        show={osModal}
        onHide={() => setOsModal(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        animation={false}
        centered
        size="lg"
      >
        <OSModal close={() => setOsModal(false)} serviceOrder={serviceOrder} />
      </Modal>
      {loading ? <Loading /> : null}
    </>
  );
};

export default Manutencao;
